import Honeybadger from '@honeybadger-io/js';

// Filtering Honeybadger Errors
//
// It's a fun side effect of running in the browser that we have no real control of what
// goes on, so we are often alerted oto errors that don't originate from our code, and
// that we can't fix. To keep the signal to noise ratio low we testing and filter out
// errors we don't care about before sending them to Honeybadger.
//
// Each filter function should return a boolean, where true means we filter the error
// (don't send it to Honeybadger) and false means we notify. Each filter function should
// be added to the `filters` variable, so they are compared for each error that gets raised.
function silenceBrowserExtensionErrors(notice) {
  let expression = new RegExp(
    '(safari-extension|moz-extension|chrome-extension)://',
  );

  return expression.test(notice.stack);
}

function silenceUserScriptErrors(notice) {
  return notice.backtrace[0] && /^user-script.*/.test(notice.backtrace[0].file);
}

function silenceAnonymousErrors(notice) {
  return notice.backtrace[0] && notice.backtrace[0].file == '<anonymous>';
}

function silenceByMessage(notice) {
  let messages = [
    'MyApp_RemoveAllHighlights',
    "Failed to execute 'transaction' on 'IDBDatabase'",
    'setAdGeneParamsForiOSApp',
    'instantSearchSDKJSBridgeClearHighlight',
  ];

  return messages.some(function (message) {
    let expression = new RegExp(`.*${message}.*`);

    return expression.test(notice.message);
  });
}

let filters = [
  silenceBrowserExtensionErrors,
  silenceUserScriptErrors,
  silenceAnonymousErrors,
  silenceByMessage,
];

Honeybadger.beforeNotify(function (notice) {
  // If any filters return true then we want to ignore the error
  return filters.every(function (filter) {
    return !filter(notice);
  });
});

// Ensure that Honeybadger is exposed to window object.
global.Honeybadger = Honeybadger;
global.honeybadger = Honeybadger;

// initHoneybadger is defined in "shared/_honeybadger.html.erb" as it contains
// additional context from Rails side.
if (global.initHoneybadger !== undefined) {
  global.initHoneybadger();
} else {
  console.warn(
    'initHoneybadger function not present. Will proceed without error reporting.',
  );
}
